export const isPublicRoute = (pathname: string) => {
  // Define public routes that don't require authentication
  const publicRoutes = [
    '/',
    '/login',
    '/create-account',
    '/forgotten-password',
    '/reset-password',
    '/resetpassword',
    '/activate-account',
    '/acitvate-account', // Keep this typo for backward compatibility
    '/confirm-email',
    '/waiting-list',
    '/checkout',
    '/logout',
    '/auth/gocardlesscomplete',
    '/classes',
    '/payment-complete',
    '/signup/invite',
    '/maintenance',
    '/plans',
    '/marketing',
    '/signup',
    '/find-pt',
  ];

  const isPublic = publicRoutes.some(route => {
    // Exact match
    if (pathname === route) return true;
    // Check if pathname starts with the route (for query parameters)
    if (pathname.startsWith(route + '?')) return true;
    return false;
  }) || 
  // Additional pattern matching for routes with parameters
  pathname.startsWith('/create-account') ||
  pathname.startsWith('/forgotten-password') ||
  pathname.startsWith('/reset-password') ||
  pathname.startsWith('/activate-account') ||
  pathname.startsWith('/acitvate-account') ||
  pathname.startsWith('/confirm-email') ||
  pathname.startsWith('/waiting-list') ||
  pathname.startsWith('/checkout') ||
  pathname.startsWith('/auth/gocardlesscomplete') ||
  pathname.startsWith('/payment-complete') ||
  pathname.startsWith('/classes') ||
  pathname.startsWith('/signup/invite') ||
  // The member link in an invitation email. Logged out people see the offer first and log in from there.
  pathname.startsWith('/accept-subscription-offer/') ||
  pathname.startsWith('/pt/') ||
  pathname.startsWith('/plans') ||
  pathname.startsWith('/marketing') ||
  pathname.startsWith('/signup/venue-admin') ||
  pathname.startsWith('/signup/venue');

  return isPublic;
}